import { Component, Input } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

@Component({
  template: `
      <ion-list>
        <ion-list-header>{{title}}</ion-list-header>
        <button *ngFor="let item of actions" ion-item (click)="didTap(item)">{{item.title}}</button>
        <button ion-item (click)="close()">Abbrechen</button>
      </ion-list>
    `
})
export class SimpleOptionPopoverComponent {
  @Input() public title: string;
  @Input() public actions: [{ title: string, userdata: any }];

  constructor(public viewCtrl: ViewController, private navParams: NavParams) {
    this.title = navParams.get('title');
    this.actions = navParams.get('actions');

  }

  public didTap(item: { title: string, userdata: any }) {
    this.viewCtrl.dismiss(item.userdata);
  }

  public close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/licensesComponent/simple-option-popover.component.ts